<template lang="html">
	<div class="message"></div>
</template>

<script>
export default {
	props: {
		message: {
			default: function () {
				return {
					name: 'Madison Insurance',
					categories: ['General', 'Motor'],
					reference: 512,
					currency: '$',
					price: 590,
					month: 'Feb',
					date: '28',
					year: '/20',
				};
			},
		},
	},
	data() {
		return {
			utils,
		};
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.message {
}
</style>
